import { PropTypes } from 'react-desc';
import { o as orientation } from '../prop-types-cc01d273.js';

var props = {
  /** Inject props to component wrapper  */
  containerProps: PropTypes.object.description('Inject props to component wrapper'),

  /**
   * Allows a function that is triggered once the radio group changes
   */
  onChange: PropTypes.func.description('Allows a function that is triggered once the radio group changes'),

  /**
   * Selected default active value
   */
  activeValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('Selected default active value'),

  /**
   * Radio group items to show of type DSRadio
   */
  children: PropTypes.arrayOf(PropTypes.element).isRequired.description('Radio group items to show of type DSRadio'),

  /**
   * ['horizontal', 'vertical']
   */
  orientation: PropTypes.oneOf(orientation).description("['horizontal', 'vertical']"),

  /**
   * Whether the radio group is disabled or not
   */
  disabled: PropTypes.bool.description(''),
  labelProps: PropTypes.shape({
    feedbackMessage: PropTypes.string,
    labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    required: PropTypes.bool
  }).description('Whether the radio group is disabled or not')
};

export { props };
//# sourceMappingURL=props.js.map
